<template>
  <div>
    <b-row>
      <b-col cols="12" md="6">
        <b-form-group
          :label="`${$lang.surveyLang.survey_term}: `"
          label-for="term"
          :label-cols="this.$config.form.labelCol"
        >
          <requiredComponent
            v-if="mode === 'add'"
            slot="label"
            :label="`${$lang.surveyLang.survey_term}: `"
            :rules="$v.term_selected.$params"
          />
          <selectAsync
            :options="term_options"
            v-model="$v.term_selected.$model"
            label="caption"
            :disabled="mode === 'edit'"
            :asyncFind="getTerms"
            :loading="term_loading"
            :isValid="$v.term_selected.$dirty ? !$v.term_selected.$error : null"
          />
          <b-form-invalid-feedback
            :style="{
              display: $v.term_selected.$error ? 'block' : 'none',
            }"
            id="term_selected_feedback"
          >
            {{ $lang.error_required | replace($lang.surveyLang.survey_term) }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col cols="12" md="6">
        <b-form-group
          :label="`${$lang.surveyLang.survey_name}: `"
          label-for="research_visit_location"
          :label-cols="12"
        >
          <requiredComponent
            slot="label"
            :label="`${$lang.surveyLang.survey_name}: `"
            :rules="$v.name.$params"
          />
          <b-form-input
            id="name"
            type="text"
            :state="$v.name.$dirty ? !$v.name.$error : null"
            v-model="$v.name.$model"
          ></b-form-input>

          <b-form-invalid-feedback id="name-feedback">
            {{ $lang.error_required | replace($lang.surveyLang.survey_name) }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col cols="12" md="6">
        <b-form-group
          :label="`${$lang.surveyLang.survey_start_at}: `"
          label-for="start_at"
          :label-cols="$config.form.labelCol"
        >
          <requiredComponent
            :titleText="$lang.surveyLang.survey_start_at_tooltip"
            slot="label"
            :label="`${$lang.surveyLang.survey_start_at}: `"
            :rules="$v.start_at.$params"
          />
          <date-picker
            v-model="$v.start_at.$model"
            type="datetime"
            :state="$v.start_at.$dirty ? !$v.start_at.$error : null"
            inputReq="true"
            format="YYYY-MM-DD HH:mm:ss"
            display-format="jYYYY/jMM/jDD ساعت HH:mm"
            clearable
            :min="new Date() | moment('YYYY/MM/DD')"
            :class="
              $v.start_at.$dirty
                ? $v.start_at.$error
                  ? 'invalid-date'
                  : 'valid-date'
                : null
            "
          >
          </date-picker>

          <b-form-invalid-feedback
            :style="{
              display: $v.start_at.$error ? 'block' : 'none',
            }"
            id="start_at-feedback"
          >
            {{
              $lang.error_required | replace($lang.surveyLang.survey_start_at)
            }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col cols="12" md="6">
        <b-form-group
          :label="`${$lang.surveyLang.survey_end_at}: `"
          label-for="end_at"
          :label-cols="$config.form.labelCol"
        >
          <requiredComponent
            :titleText="$lang.surveyLang.survey_end_at_tooltip"
            slot="label"
            :label="`${$lang.surveyLang.survey_end_at}: `"
            :rules="$v.end_at.$params"
          />
          <date-picker
            v-model="$v.end_at.$model"
            type="datetime"
            :state="$v.end_at.$dirty ? !$v.end_at.$error : null"
            inputReq="true"
            format="YYYY-MM-DD HH:mm:ss"
            display-format="jYYYY/jMM/jDD ساعت HH:mm"
            clearable
            :min="$v.start_at.$model | moment('YYYY-MM-DD HH:mm')"
            :class="
              $v.end_at.$dirty
                ? $v.end_at.$error
                  ? 'invalid-date'
                  : 'valid-date'
                : null
            "
          >
          </date-picker>

          <b-form-invalid-feedback
            :style="{
              display: $v.end_at.$error ? 'block' : 'none',
            }"
            id="end_at-feedback"
          >
            {{ $lang.error_required | replace($lang.surveyLang.survey_end_at) }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col cols="12" md="12" v-if="mode === 'edit'">
        <b-form-group
          :label="`${$lang.surveyLang.survey_group_status}: `"
          label-for="status"
          :label-cols="this.$config.form.labelCol"
        >
          <requiredComponent
            slot="label"
            :label="`${$lang.surveyLang.survey_group_status}: `"
            :rules="$v.status.$params"
          />
          <b-form-checkbox v-model="status" name="check-button" switch>
            <b v-if="status" v-text="'فعال'" class="text-success" />
            <b v-else v-text="'غیرفعال'" class="text-danger" />
          </b-form-checkbox>
        </b-form-group>
      </b-col>
      <b-col
        cols="12"
        class="text-right mt-3"
        v-if="
          includes('admin', parentPermissions) ||
          includes('edit', parentPermissions)
        "
      >
        <b-button variant="success" @click="submit">
          {{ $lang.submitButton }}
          <i class="fa fa-check"></i>
        </b-button>
        <b-button
          type="reset"
          class="ml-2"
          size="md"
          variant="danger"
          @click="close"
        >
          {{ $lang.close }}
          <i class="fa fa-ban"></i>
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { pathOr, includes } from "ramda";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import { required, requiredIf } from "vuelidate/lib/validators";

export default {
  validations: {
    name: { required },
    term_selected: { requiredIf: requiredIf((vm) => vm.mode === "add") },
    start_at: { required },
    end_at: { required },
    status: {},
  },
  components: {
    datePicker: VuePersianDatetimePicker,
  },
  props: {
    item: {
      type: Object,
      default: null,
    },
    parentPermissions: {
      type: Array,
      default: () => [],
    },
    mode: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      name: null,
      term_selected: null,
      term_options: [],
      term_loading: false,
      start_at: null,
      end_at: null,
      status: false,
    };
  },
  watch: {
    item(value) {
      value && this.fetchData();
    },
  },
  methods: {
    pathOr,
    includes,
    submit() {
      this.$v.$touch();
      if (this.$v.$anyError) return;
      let payload = {
        name: this.name,
        start_at: this.start_at,
        end_at: this.end_at,
      };
      if (this.mode === "add") {
        const term_id = pathOr(null, ["id"], this.term_selected);
        payload = { ...payload, term_id };
      }
      if (this.mode === "edit") {
        payload = { ...payload, is_enable: this.status };
      }
      this.$emit("submit", payload);
    },
    close() {
      this.$emit("close");
    },
    async getTerms(query) {
      if (!query || query.length < 2) {
        return;
      }
      if (query.length > 2) {
        this.term_options = [];
      }

      try {
        this.term_loading = true;
        const url = `${this.$config.api_url}${this.$config.profile.term_combo}?search_txt=${query}`;
        const response = await this.$httpService.get(url);
        this.term_options = pathOr([], ["data", "data"], response).map(
          (item) => {
            return {
              caption: `${pathOr("", ["id"], item)} - ${pathOr(
                "",
                ["caption"],
                item
              )}`,
              id: pathOr(null, ["id"], item),
            };
          }
        );
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.term_loading = false;
      }
    },
    async fetchData() {
      if (this.item && Object.keys(this.item).length) {
        this.name = pathOr(null, ["name"], this.item);
        this.term_selected = pathOr(null, ["term"], this.item);
        this.start_at = pathOr(null, ["start_at", "gregorian"], this.item);
        this.end_at = pathOr(null, ["end_at", "gregorian"], this.item);
        this.status = pathOr(false, ["is_enable"], this.item);
      }
    },
  },
};
</script>
